import type { Rating } from '@types'
import axios from 'axios'

import env from '../environments'

export async function createRating(data: Partial<Rating>) {
	const response = await axios.post(env.apiUrl + '/ratings', data)

	return response.data as Rating
}
